import React, { useState } from 'react';
import { useTranslation } from '@wix/cli-i18n';
import { useGenerationTask } from '../hooks/use-generation-task.js';
import { useProjectModel } from '../../../model.js';
import { generateEvent } from './generate.js';
import { ChooseFolderStep } from './steps.js';
import {
  CompleteGeneration,
  CompleteGenerationMessage,
} from '../CompleteGeneration.js';

export const useGenerateEvent = () => {
  const { t } = useTranslation();
  const { model } = useProjectModel();
  const [eventFolder, setEventFolder] = useState<string>();
  const extensionType = t('generate_command.flow.event').toLowerCase();

  const generationTask = useGenerationTask(async () => {
    if (eventFolder) {
      return generateEvent(model.projectFolder, eventFolder);
    }
  }, [model.projectFolder, eventFolder]);

  return [
    <ChooseFolderStep onSubmit={setEventFolder} eventFolder={eventFolder} />,
    <CompleteGeneration
      generationTask={generationTask}
      extensionType={extensionType}
      successMessage={CompleteGenerationMessage.SuccessMessage({
        // https://dev.wix.com/docs/build-apps/develop-your-app/frameworks/wix-cli/supported-extensions/backend-extensions/events/add-event-extensions-with-the-cli
        learnMoreUrl: 'https://wix.to/7XWf4LU',
      })}
      route={eventFolder}
    />,
  ];
};
